import React, { useEffect, useState } from "react";
import "./conversations.css";
// import API_Root from "../../Constants/API_Root";
import API_Root from "../../../../Constants/API_Root";
// import { authFetch } from "../../Authentication/authService";
import { authFetch } from "../../../../Authentication/authService";

const Conversations = () => {
  const [conversationList, setConversationList] = useState([]);
  const [conversationLoading, setConversationLoading] = useState(true);
  const [conversationError, setConversationError] = useState("");

  useEffect(() => {
    fetchConversations();
  }, []);

  const fetchConversations = async () => {
    setConversationLoading(true);
    setConversationError("");
  
    try {
      const response = await authFetch(
        `https://api-discloseai.essolutions.ai/api/v1/workspace/fetch-conversations-wrkspc`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            org_id: 8,
          }),
        }
      );
  
      if (!response.ok) {
        throw new Error("Failed to fetch conversations");
      }
  
      const data = await response.json();
  
      // Show latest conversations first
      setConversationList(
        Array.isArray(data) ? [...data].reverse() : []
      );
    } catch (err) {
      console.error("Conversation fetch error:", err);
      setConversationError("Unable to load conversations.");
    } finally {
      setConversationLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString([], {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="conversationPageWrapper">
      <div className="conversationPageHeader">
        <h2>Conversation History</h2>
        <button
          className="conversationRefreshBtn"
          onClick={fetchConversations}
        >
          Refresh
        </button>
      </div>

      {conversationLoading ? (
        <div className="conversationLoadingState">
          Loading conversations...
        </div>
      ) : conversationError ? (
        <div className="conversationErrorState">
          {conversationError}
        </div>
      ) : conversationList.length === 0 ? (
        <div className="conversationEmptyState">
          No conversations found.
        </div>
      ) : (
        <div className="conversationCardsContainer">
          {conversationList.map((item, index) => (
            <div className="conversationCard" key={index}>
              <div className="conversationCardTop">
                <span className="conversationNamespace">
                  {item.namespace}
                </span>

                <span className="conversationDate">
                  {formatDate(item.created_at)}
                </span>
              </div>

              <div className="conversationSection">
                <div className="conversationLabel">
                  Question
                </div>

                <div className="conversationQuestion">
                  {item.question}
                </div>
              </div>

              <div className="conversationSection">
                <div className="conversationLabel">
                  Answer
                </div>

                <div className="conversationAnswer">
                  {item.answer}
                </div>
              </div>

              <div className="conversationFooter">
                <span>
                  <strong>Model:</strong> {item.model_used}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Conversations;